<template>
  	<b-container fluid>
		<page-title><h2 v-if="item"><router-link :to="{ name: 'UserList' }" class="nav-link">Użytkownicy</router-link>/Edycja</h2></page-title>
		<div class="col page-element">
			<div v-if="created" class="alert alert-success" role="status">{{ created['@id'] }} created.</div>
			<div v-if="updated" class="alert alert-success" role="status">{{ updated['@id'] }} updated.</div>
			<alert-loading v-if="retrieveLoading || updateLoading"></alert-loading>
			<div v-if="retrieveError" class="alert alert-danger" role="alert"><span class="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span> {{ retrieveError }}</div>
			<div v-if="updateError" class="alert alert-danger" role="alert"><span class="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span> {{ updateError }}</div>
			<div v-if="deleteError" class="alert alert-danger" role="alert"><span class="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span> {{ deleteError }}</div>

			<UserForm v-if="item && !retrieveLoading" :handle-submit="update" :values="item" :errors="violations" :initialValues="retrieved"></UserForm>
		</div>
	</b-container>
</template>

<script>
  import UserForm from './Form.vue';
  import { mapGetters } from 'vuex';

  export default {
    created () {
      this.$store.dispatch('user/update/retrieve', decodeURIComponent(this.$route.params.id));
    },
    components: {
      UserForm
    },
    computed: {
      ...mapGetters({
        retrieveError: 'user/update/retrieveError',
        retrieveLoading: 'user/update/retrieveLoading',
        updateError: 'user/update/updateError',
        updateLoading: 'user/update/updateLoading',
        deleteError: 'user/del/error',
        deleteLoading: 'user/del/loading',
        created: 'user/create/created',
        deleted: 'user/del/deleted',
        retrieved: 'user/update/retrieved',
        updated: 'user/update/updated',
        violations: 'user/update/violations'
      })
    },
    data: function() {
      return {
        item: {}
      }
    },
    methods: {
      update (values) {
        this.$store.dispatch('user/update/update', {item: this.retrieved, values: values });
      },
      del () {
        if (window.confirm('Czy na pewno chce usunąć tego użytkownika?'))
          this.$store.dispatch('user/del/delete', this.retrieved);
      },
      reset () {
        this.$store.dispatch('user/update/reset');
        this.$store.dispatch('user/del/reset');
        this.$store.dispatch('user/create/reset');

      }
    },
    watch: {
      deleted: function (deleted) {
        if (deleted) {
          this.$router.push({ name: 'UserList' });
        }
      }
    },
    beforeDestroy() {
      this.reset();
    }
  }
</script>



// WEBPACK FOOTER //
// Update.vue?253b43b8